// extracted by mini-css-extract-plugin
module.exports = {"root":"Mask_root__tGNsU","circle":"Mask_circle__30mtq","square":"Mask_square__2c7ZX","rounded":"Mask_rounded__3iDOU","wash":"Mask_wash__2AVcE"};